import { LocalDate } from "@js-joda/core";
import { PeriodNavigator } from "components/designV2/periodNavigator/periodNavigator";
import { Text } from "components/designV2/text/text";
import { TooltipHover } from "components/designV2/tooltip/tooltip";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import {
  HeaderRightAligned,
  IndividualSalaryFilters,
  PeriodNavigatorContainer,
  SalaryPageContainer,
} from "./salary.styled";
import { ColorV2 } from "config/colors";
import { Api } from "services/api/api.service";
import { FileViewer } from "../fileViewer/fileViewer.component";
import { AGIList } from "./agiList.component";

export const AGIOverview = (): JSX.Element => {
  const [currentDate, setCurrentDate] = useState(
    LocalDate.now().minusMonths(1),
  );
  const [{ company }] = useCompanyStore();
  const { t } = useTranslation();

  return (
    <SalaryPageContainer>
      <HeaderRightAligned>
        <TooltipHover text={t("Salary.AGIInfo")} arrow="up">
          <Text typography="s1" color={ColorV2.Blue1}>
            {t("Salary.WhatIs", { name: t("Salary.AGI").toLowerCase() })}
          </Text>
        </TooltipHover>
      </HeaderRightAligned>
      <IndividualSalaryFilters>
        <div />
        <PeriodNavigatorContainer>
          <PeriodNavigator
            currentDate={currentDate}
            mode="month"
            onChange={setCurrentDate}
          />
        </PeriodNavigatorContainer>
        <div />
      </IndividualSalaryFilters>

      {company && (
        <FileViewer
          fetchEndpoint={() =>
            Api().company.salary.getAGI(
              company.id,
              currentDate.year(),
              currentDate.monthValue(),
            )
          }
          filename={`AGI_${currentDate.year()}_${currentDate.monthValue()}.xml`}
          type="application/xml"
          currentDate={currentDate}
          ListComponent={AGIList}
        />
      )}
    </SalaryPageContainer>
  );
};
